import App from "../App";
import Login from "../routes/login/login";
import Menu from "../routes/menu/menu";
import UserList from "../routes/userManage/userList/userList";
import UserFriend from "../routes/userManage/userAdd/userFriends";
import UserListSearch from "../routes/userManage/userList/userListSearch/userListSearch";
import AddUser from "../routes/userManage/userAdd/userAdd";
import UserFuncRenew from "../routes/userManage/userAdd/userFuncRenew";
import BatchUserRenew from "../routes/userManage/userList/batchUserRenew";
import SetFunctions from "../routes/userManage/userAdd/setFunctions";
import SetIccids from "../routes/userManage/userAdd/setIccids";
import TransferUsersRecord from "../routes/userManage/transferUsersRecord/transferUsersRecord";
import BindingImei from "../routes/userManage/bindingImei/bindingImei";
import BindingIccid from "../routes/userManage/bindingIccid/bindingIccid";
import TransferUsers from "../routes/adminManage/adminDetail/transferUsers";
import AddAdmin from "../routes/adminManage/addAdmin/addAdmin";
import CurrencyRecord from "../routes/adminManage/currencyRecord/currencyRecord";
import adminRetrieve from "../routes/adminManage/adminRetrieve/adminRetrieve";
import Adminlist from "../routes/adminManage/adminList";
import UserSelectList from "../routes/userManage/userAdd/userSelectList";
import UserSelectGroup from "../routes/userManage/userAdd/userSelectGroup";
import BillExchange from "../routes/billManage/billExchange/billExchange";
import AdminDetail from "../routes/adminManage/adminDetail/adminDetail";
import AdminNum from "../routes/adminManage/adminDetail/adminNum";
import AdminPermission from "../routes/adminManage/adminDetail/adminPermission";
import AssignFuncGroup from "../routes/adminManage/adminDetail/assignFuncGroup";
import FuncDetail from "../routes/funcManage/funcDetail";
import AdminFuncRenew from "../routes/adminManage/adminDetail/adminFuncRenew";
import BillList from "../routes/billManage/billList/billList";
import BillDetails from "../routes/billManage/billDetail/billDetail";
import BillMessage from "../routes/billManage/billMessage/billMessage";
import Addgroup from "../routes/groupManage/addGroup/addGroup";
import Selectuser from "../routes/groupManage/addGroup/selectUser";
import SelectList from "../routes/groupManage/addGroup/selectList";
import GroupList from "../routes/groupManage/groupList/groupList";
import GroupDetails from "../routes/groupManage/groupList/groupDetails";
import GroupUserList from "../routes/groupManage/groupList/groupUserList";
import GroupCombination from "../routes/groupManage/groupCombination/index";
import GroupPrefixList from "../routes/groupManage/groupPrefix/groupPrefixList"
import addGroupPrefix from "../routes/groupManage/addGroupPrefix/addGroup"
import GroupPrefixDetails from "../routes/groupManage/groupPrefix/groupPrefixDetails.js"
import editGroupPrefix from '../routes/groupManage/editGroupPrefix';
import PrefixInfo from "../routes/groupManage/groupPrefix/prefixInfo"
import EditUser from "../routes/userManage/userList/userEdit";
import RemoteWrite from "../routes/userManage/userAdd/remoteWrite";
import Register from "../routes/register";
import userList from "../models/userList";
import Clockin from '../routes/clockin/clockin';
import uploadImg from '../routes/clockin/uploadImg/uploadImg'
import Tdakak from '../routes/clockin/daka/Tdakak'
import Tdaka from '../routes/clockinsdk/Tdaka/Tdaka'
import Clockinsdk from "../routes/clockinsdk/clockinsdk";
import ClockinICCID from "../routes/clockinICCID/clockinICCID"
import Dakatale from "../routes/clockinsdk/dakatale/Dakatale";
import Uplist from "../routes/clockinsdk/uplist/uplist";
import {SimInfo} from '../routes/simManage/simInfo/simInfo';
import { locationMsg } from '../routes/locationMsg';
import DMRDevice from "../routes/theturntable/list/index"
import SetDeviceInfo from "../routes/theturntable/deviceInfo/setDeviceInfo"
import DeviceInfo from "../routes/theturntable/deviceInfo/deviceInfo";
import IpvInfo from "../routes/ipv/ipvInfo";
import batchImei from "../routes/clockinsdk/batchImei/batchImei";
import { name } from "file-loader";

import enterpriseadminlist from '../routes/enterprise/admin/enterpriseadminlist/index.js'
import enterpriseadminadd from '../routes/enterprise/admin/enterpriseadminadd/addAdmin.js'
import enterpriseAdminDetail from '../routes/enterprise/admin/enterpriseadmindetail/adminDetail.js'
import enterpriseAdmin from '../models/enterprise/enterpriseAdmin.js'

import enterprisegrouplist from '../routes/enterprise/group/enterprisegrouplist/groupList.js'
import enterprisegroupadd from '../routes/enterprise/group/enterprisegroupadd/addGroup.js'
import enterpriseGroup from '../models/enterprise/enterpriseGroup.js'

import enterpriseuserlist from '../routes/enterprise/user/enterpriseuserlist/userList.js'
import enterpriseUser from '../models/enterprise/enterpriseUser.js'
const menuGlobal = [{
    id: "app",
    pid: "0",
    name: "app",
    path: "/",
    // models: () => [import('./models/aaa')],
    component: () => Menu,
},
{
    id: "login",
    pid: "0",
    name: "login", 
    path: "/login",
    // models: () => [import('./models/aaa')],
    component: () => Login,
},
{
    id: "register",
    pid: "4",
    name: "register",
    path: "/register",
    component: () => Register,
},
{
    id: "menu",
    pid: "1",
    name: "menu",
    path: "/menu",
    models: () => [import("../models/group.js")],
    component: () => Menu,
},
{
    id: "userlist",
    pid: "2",
    name: "userlistssss",
    path: "/userlist",
    models: () => [userList],
    component: () => UserList,
},
{
    id: "userfriend",
    pid: "2",
    name: "userfriend",
    path: "/userfriend/:uid?",
    models: () => [userList],
    component: () => UserFriend,
},
{
    id: "userlistsearch",
    pid: "3",
    name: "userlistsearch",
    path: "/userlistsearch",
    // models: () => [import('./models/ccc')],
    component: () => UserListSearch,
},
{
    id: "adduser",
    pid: "2",
    name: "adduser",
    path: "/adduser/:id?/:type?",
    models: () => [import("../models/group.js")],
    component: () => AddUser,
},
{
    id: "remotewrite",
    pid: "2",
    name: "remotewrite",
    path: "/remotewrite/:id?/:name?/:imei?",
    models: () => [import("../models/group.js")],
    component: () => RemoteWrite,
},
{
    id: "useredit",
    pid: "2",
    name: "useredit",
    path: "/useredit/:id?/:type?",
    // models: () => [import('./models/ccc')],
    component: () => EditUser,
},
{
    id: "userFuncRenew",
    pid: "2",
    name: "userFuncRenew",
    path: "/userFuncRenew/:uid?/:type?/:userType?",
    component: () => UserFuncRenew,
},
{
    id: "batchUserRenew",
    pid: "2",
    name: "batchUserRenew",
    path: "/batchUserRenew",
    component: () => BatchUserRenew,
},
{
    id: "setFunctions",
    pid: "2",
    name: "setFunctions",
    path: "/setFunctions/:uid?",
    component: () => SetFunctions,
},
{
    id: "setIccids",
    pid: "2",
    name: "setIccids",
    path: "/setIccids/:uid?",
    component: () => SetIccids,
},
{
    id: "transferUsersRecord",
    pid: "2",
    name: "transferUsersRecord",
    path: "/transferUsersRecord",
    component: () => TransferUsersRecord,
},
{
    id: "bindingImei",
    pid: "2",
    name: "bindingImei",
    path: "/bindingImei",
    component: () => BindingImei,
},
{
    id: "BindingIccid",
    pid: "2",
    name: "bindingIccid",
    path: "/bindingIccid",
    models: () => [import("../models/group.js")],
    component: () => BindingIccid,
},
{
    id: "transferUsers",
    pid: "2",
    name: "transferUsers",
    path: "/transferUsers/:loginName?/:id?",
    component: () => TransferUsers,
},
{
    id: "addadmin",
    pid: "2",
    name: "addadmin",
    path: "/addadmin/:loginName?/:type?/:id?",
    // models: () => [import('./models/ccc')],
    component: () => AddAdmin,
},
{
    id: "adminlist",
    pid: "2",
    name: "adminlist",
    path: "/adminlist",
    // models: () => [import('./models/ccc')],
    component: () => Adminlist,
},
{
    id: "admindetail",
    pid: "2",
    name: "admindetail",
    path: "/admindetail/:name?/:flag?/:id?",
    component: () => AdminDetail,
},
{
    id: "adminnum",
    pid: "2",
    name: "adminnum",
    path: "/adminnum/:name?/:type?/:id?",
    // models: () => [import("../models/admin/")],
    component: () => AdminNum,
},
{
    id: "adminPermission",
    pid: "2",
    name: "adminPermission",
    path: "/adminPermission/:id?",
    component: () => AdminPermission,
},
{
    id: "assignFuncGroup",
    pid: "2",
    name: "assignFuncGroup",
    path: "/assignFuncGroup/:id?",
    component: () => AssignFuncGroup,
},
{
    id: "FuncDetail",
    pid: "2",
    name: "FuncDetail",
    path: "/funcDetail/:name?/:id?",
    component: () => FuncDetail,
},
{
    id: "adminFuncRenew",
    pid: "2",
    name: "AdminFuncRenew",
    path: "/adminFuncRenew/:id?",
    component: () => AdminFuncRenew,
},
{
    id: "currencyrecord",
    pid: "2",
    name: "currencyrecord",
    path: "/currencyrecord/:loginName?/:type?/:id?",
    component: () => CurrencyRecord,
},
{
    id: "adminretrieve",
    pid: "2",
    name: "adminretrieve",
    path: "/adminretrieve",
    component: () => adminRetrieve,
},
{
    id: "userselectlist",
    pid: "2",
    name: "userselectlist",
    path: "/userselectlist",
    component: () => UserSelectList,
},
{
    id: "userselectgroup",
    pid: "2",
    name: "userselectgroup",
    path: "/userselectgroup",
    models: () => [import("../models/group.js")],
    component: () => UserSelectGroup,
},
{
    id: "grouplist",
    pid: "2",
    name: "grouplist",
    path: "/grouplist",
    // models: () => [import('./models/ccc')],
    component: () => GroupList,
},
{
    id: "addgroup",
    pid: "2",
    name: "addgroup",
    path: "/addgroup/:type?/:gid?/:name?",
    models: () => [import("../models/group/userSelectList")],
    component: () => Addgroup,
},
{
    id: "selectuser",
    pid: "2",
    name: "selectuser",
    path: "/selectuser",
    models: () => [import("../models/group/userSelectList")],
    component: () => Selectuser,
},
{
    id: "selectlist",
    pid: "2",
    name: "selectlist",
    path: "/selectlist",
    models: () => [import("../models/group/userSelectList")],
    component: () => SelectList,
},
{
    id: "groupdetails",
    pid: "2",
    name: "groupdetails",
    path: "/groupdetails",
    // models: () => [import('./models/ccc')],
    component: () => GroupDetails,
},
{
    id: "groupuserlist",
    pid: "2",
    name: "groupuserlist",
    path: "/groupuserlist/:gid?/:name?",
    // models: () => [import('./models/ccc')],
    component: () => GroupUserList,
},
{
    id: "groupcombination",
    pid: "2",
    name: "groupcombination",
    path: "/groupcombination",
    // models: () => [import('./models/ccc')],
    component: () => GroupCombination,
},
{
    id: "groupPrefixList",
    pid: "2",
    name: "groupPrefixList",
    path: "/groupPrefixList",
    // models: () => [import('./models/ccc')],
    component: () => GroupPrefixList,
},
{
    id: "addGroupPrefix",
    pid: "2",
    name: "addGroupPrefix",
    path: "/addGroupPrefix",
    models: () => [import("../models/group/userSelectList")],
    component: () => addGroupPrefix,
},
{
    id: "groupPrefixDetails",
    pid: "2",
    name: "groupPrefixDetails",
    path: "/groupPrefixDetails",
    // models: () => [import('./models/ccc')],
    component: () => GroupPrefixDetails,
},
{
    id: "editGroupPrefix",
    pid: "2",
    name: "editGroupPrefix",
    path: "/editGroupPrefix",
    // models: () => [import('./models/ccc')],
    component: () => editGroupPrefix,
},
{
    id: "prefixInfo",
    pid: "2",
    name: "prefixInfo",
    path: "/prefixInfo/:name?/:iccid?",
    // models: () => [import('./models/ccc')],
    component: () => PrefixInfo,
},
{
    id: "billexchange",
    pid: "2",
    name: "billexchange",
    path: "/billexchange",
    // models: () => [import('./models/ccc')],
    component: () => BillExchange,
},
{
    id: "billlist",
    pid: "2",
    name: "billlist",
    path: "/billlist",
    models: () => [import("../models/bill/index")],
    component: () => BillList,
},
{
    id: "billdetails",
    pid: "2",
    name: "billdetails",
    path: "/billdetails/:id?",
    models: () => [import("../models/bill/index")],
    component: () => BillDetails,
},
{
    id: "billmessage",
    pid: "2",
    name: "billmessage",
    path: "/billmessage",
    // models: () => [import('./models/ccc')],
    component: () => BillMessage,
},
{
    id: "clockinICCID",
    pid:"2",
    name:"clockinICCID",
    path:"/clockinICCID",
    models: () => [import("../models/group.js")],
    component: () => ClockinICCID,
},
{
    id: "clockinsdk",
    pid: '2',
    name: "clockinsdk",
    path: "/clockinsdk/:id?",
    models: () => [import("../models/group.js")],
    component: () => Clockinsdk,
},
{
    id: "Clockin",
    pid: '2',
    name: "Clockin",
    path: "/Clockin",
    component: () => Clockin,
},
{
    id: "Tdakak",
    pid: '2',
    name: "Tdakak",
    path: "/Tdakak/:id?/:name?",
    component: () => Tdakak,
},
{
    id: "batchImei",
    pid: '2',
    name: "batchImei",
    path: "/batchImei",
    component: () => batchImei,
},
{
    id: "uploadImg",
    pid: '2',
    name: "uploadImg",
    path: "/uploadImg/:id?/:name?",
    component: () => uploadImg,
},
{
    id: "Tdaka",
    pid: '2',
    name: "Tdaka",
    path: "/Tdaka",
    models: () => [import("../models/group.js")],
    component: () => Tdaka,
},

{
    id: "uplist",
    pid: '3',
    name: "uplist",
    path: "/uplist",
    component: () => Uplist,
},
{
    id: "Dakatale",
    pid: '2',
    name: "Dakatale",
    path: "/Dakatale",
    component: () => Dakatale,
},
{
    id: 'simInfo',
    pid: '2',
    name: 'simInfo',
    path: '/simInfo',
    // models: () => [import('./models/ccc')],
    component: () => SimInfo
},
{
    id: 'theturntableList',
    pid: '2',
    name:'theturntableList',
    path:'/theturntableList',
    component: ()=> DMRDevice
},
{
    id: 'deviceInfo',
    pid: '2',
    name:'deviceInfo',
    path:'/deviceInfo',
    component: () => DeviceInfo

},
{
    id: 'setDeviceInfo',
    pid: '2',
    name: 'setDeviceInfo',
    path: '/setDeviceInfo',
    models: () => [import("../models/group.js")],
    component: ()=> SetDeviceInfo
},
{
    id: 'locationMsg',
    pid: '2',
    name: 'locationMsg',
    path: '/locationMsg/:id?/:type?/:msg?',
    component: () => locationMsg
},
{
    id: 'ipvInfo',
    pid: '2',
    name: 'ipvInfo',
    path: '/ipvInfo',
    component: () => IpvInfo
},
{
    id: 'enterpriseAdminList',
    pid: '2',
    name: 'enterpriseAdminList',
    path: '/enterprise/admin/enterpriseAdminList',
    models: () => [enterpriseAdmin],
    component: () => enterpriseadminlist
},
{
    id: 'enterpriseAdminAdd',
    pid: '2',
    name: 'entrepriseAdminAdd',
    path: '/enterprise/admin/enterpriseAdminAdd',
    models: () => [enterpriseAdmin],
    component: () => enterpriseadminadd
},
{   
    id: 'enterpriseAdminDetail',
    pid: '2',
    name: 'enterpriseAdminDetail',
    path: '/enterpriseAdminDetail/:name?/:flag?/:id?',
    component: () => enterpriseAdminDetail
},


// 群组
{
    id:'enterpriseGroupList',
    pid: '2',
    name: 'enterpriseGroupList',
    path: '/enterprise/group/enterpriseGroupList',
    models: () => [enterpriseGroup],
    component: () => enterprisegrouplist
},
{
    id: 'enterpriseGroupAdd',
    pid: '2',
    name: 'enterpriseGroupAdd',
    path: '/enterpriseGroupAdd/:type?/:gid?/:name?/:owner?',
    models: () => [enterpriseGroup],
    component: () => enterprisegroupadd 
},

// 用户
{
    id:'enterpriseUserList',
    pid: '2',
    name: 'enterpriseUserList',
    path: '/enterprise/user/enterpriseUserList',
    models: () => [enterpriseUser],
    component: () => enterpriseuserlist
}
];

export default menuGlobal;
